import {
  GET_VISIT_OPTIONS_SUCCESS,
  JOIN_VISIT_SUCCESS
} from 'actions/api/visits'
import {
  SET_PAYMENT_METHOD
} from 'actions/visits'

export const initialState = {
  paymentMethod: null,
  rate: null,
  balance: {}
}

const parseBillingDetails = (billing) => {
  if (!billing) return {}
  const rate = billing.rate
  const balance = {
    money: billing.balance.money,
    coupons: {
      local: billing.balance.coupons.local,
      remote: billing.balance.coupons.remote,
      universal: billing.balance.coupons.universal
    }
  }
  return {
    rate,
    balance
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAYMENT_METHOD: {
      return {
        ...state,
        paymentMethod: action.paymentMethod
      }
    }
    case JOIN_VISIT_SUCCESS:
    case GET_VISIT_OPTIONS_SUCCESS: {
      return {
        ...state,
        ...parseBillingDetails(action.response.billing)
      }
    }
  }
  return state
}
